/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { DateRangePicker } from 'react-dates';
import { START_DATE, END_DATE } from 'react-dates/constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { TODAY, getDatesFromRange } from '../../../utils/dates';

import './styles/DateRangePickerModal.css';

const DatesRangePicker = ({
  minDate,
  maxDate,
  onDatesChange,
  datesRange,
  focus,
  isDisabled
}) => {
  const [focusedInput, setFocusedInput] = useState(focus);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(moment(TODAY).startOf('day'));

  useEffect(() => {
    const d = getDatesFromRange(datesRange);
    setStartDate(d[0] ? moment(d[0]) : minDate);
    setEndDate(moment(d[1]));
  }, [datesRange]);

  useEffect(() => {
    setFocusedInput(focus);
  }, [focus]);

  const onFocusChange = fInput => {
    setFocusedInput(fInput);
  };

  const onDatesSelected = dates => {
    const end = dates.endDate ? dates.endDate.startOf('day') : null;
    const start = dates.startDate ? dates.startDate.startOf('day') : null;

    setStartDate(start);
    setEndDate(end);
    if (moment(start).isValid() && moment(end).isValid()) {
      onDatesChange(dates);
    }
  };

  const isOutsideRange = date =>
    date.isBefore(minDate) || date.isAfter(maxDate);

  return (
    <DateRangePicker
      isOutsideRange={isOutsideRange}
      disabled={isDisabled}
      endDate={endDate}
      endDateId={END_DATE}
      focusedInput={focusedInput}
      onDatesChange={onDatesSelected}
      onFocusChange={onFocusChange}
      startDate={startDate}
      startDateId={START_DATE}
      hideKeyboardShortcutsPanel
      customArrowIcon={<FontAwesomeIcon icon="arrow-right" size="1x" />}
    />
  );
};

DatesRangePicker.propTypes = {
  onClose: PropTypes.func.isRequired,
  onDatesChange: PropTypes.func.isRequired,
  minDate: PropTypes.shape({}).isRequired,
  maxDate: PropTypes.shape({}).isRequired,
  show: PropTypes.bool,
  isDisabled: PropTypes.bool
};

DatesRangePicker.defaultProps = {
  show: false,
  isDisabled: false
};

export default DatesRangePicker;
